import moment from 'moment'
// eslint-disable-next-line no-unused-vars
export const tableColumns = [
    {
      key: 'amount',
      title: '支付金额',
      ellipsis: true,
      width: 108,
      fixed: 'left',
      scopedSlots: { customRender: 'amountSlot' },
      sorter: true
    },
    {
      key: 'mchFeeAmount',
      dataIndex: 'mchFeeAmount',
      title: '商户手续费',
      // 格式 ₹0.00(0.00% + feeFixedAmount) || 0
      customRender: (text, record) => '₹' + (text || 0) + '(' + (record.mchFeeRate || 0) + '% + ' + (record.feeFixedAmount || 0) + ')',
      width: 150
    },
    {
      key: 'cusFeeAmount',
      dataIndex: 'cusFeeAmount',
      title: '客户佣金',
      customRender: (text, record) => '₹' + (text || 0) + '(' + (record.cusFeeRate || 0) + '%)',
      width: 150
    },
    {
      key: 'mchNo',
      title: '商户ID',
      dataIndex: 'mchNo',
      ellipsis: true,
      width: 190,
      sorter: true
    },
    { key: 'payOrderId', title: '平台订单ID', scopedSlots: { customRender: 'payOrderIdSlot' }, width: 250 },
    { key: 'mchOrderNo', title: '商户订单ID', scopedSlots: { customRender: 'mchOrderNoSlot' }, width: 250 },
    {
      key: 'processState',
      title: '订单状态',
      scopedSlots: { customRender: 'processStateSlot' },
      width: 120
      // sorter: true
    },
    //  回调状态  notifyState 0-未发送,  1-已发送
{
  key: 'notifyState',
  title: '回调状态',
  scopedSlots: { customRender: 'notifyStateSlot' },
  width: 120
},
    {
      key: 'upi',
      title: 'UPI',
    //   dataIndex: 'upi',
      scopedSlots: { customRender: 'upiSlot' },
      width: 160,
      sorter: true
    },
    { key: 'createdAt', dataIndex: 'createdAt', title: '创建日期', width: 180, customRender: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'), sorter: true },
    { key: 'op', title: '操作', width: '120px', fixed: 'right', align: 'center', scopedSlots: { customRender: 'opSlot' } }
  ]
